package com.dotdrives.web.pages

import com.dotdrives.design.DotButtonVariant
import com.dotdrives.model.OrgSummary
import com.dotdrives.web.shell.organizationOptionLabels
import com.dotdrives.web.ui.DotBanner
import com.dotdrives.web.ui.DotButton
import com.dotdrives.web.ui.DotCard
import react.FC
import react.Key
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

external interface OrgPickerPageProps : Props {
    var orgs: List<OrgSummary>
    var onSelect: (String) -> Unit
    var onSignOut: () -> Unit
}

val OrgPickerPage = FC<OrgPickerPageProps> { props ->
    val organizationLabels = organizationOptionLabels(props.orgs).toMap()
    div {
        className = ClassName("auth-state-page")
        div {
            className = ClassName("auth-state-panel")
            div {
                className = ClassName("signin-eyebrow dot-meta")
                +"CHOOSE A WORKSPACE"
            }
            h1 {
                className = ClassName("auth-state-title dot-heading")
                +"Where are you working today?"
            }
            p {
                className = ClassName("auth-state-copy")
                +"Choose an organization to open its fundraising workspace."
            }
            div {
                className = ClassName("org-picker-list")
                props.orgs.forEach { org ->
                    DotCard {
                        key = org.id.unsafeCast<Key>()
                        className = "org-picker-card"
                        onClick = { props.onSelect(org.id) }
                        div {
                            className = ClassName("org-picker-name")
                            +organizationLabels.getValue(org.id)
                        }
                        div {
                            className = ClassName("org-picker-meta")
                            +"${org.kind.replaceFirstChar { it.uppercase() }} · ${org.role.replaceFirstChar { it.uppercase() }}"
                        }
                    }
                }
            }
            DotButton {
                text = "Sign out"
                onClick = props.onSignOut
                variant = DotButtonVariant.Secondary
                className = "auth-state-signout"
            }
        }
    }
}

external interface BootstrapErrorPageProps : Props {
    var message: String
    var onRetry: () -> Unit
    var onSignOut: () -> Unit
}

val BootstrapErrorPage = FC<BootstrapErrorPageProps> { props ->
    div {
        className = ClassName("auth-state-page")
        DotCard {
            className = "auth-state-panel"
            h1 {
                className = ClassName("auth-state-title dot-heading")
                +"We couldn't load your workspace."
            }
            p {
                className = ClassName("auth-state-copy")
                +"Your session is still active. Retry the account setup or sign out safely."
            }
            DotBanner {
                message = props.message
                onRetry = props.onRetry
            }
            div {
                className = ClassName("auth-state-actions")
                DotButton {
                    text = "Retry"
                    onClick = props.onRetry
                }
                DotButton {
                    text = "Sign out"
                    onClick = props.onSignOut
                    variant = DotButtonVariant.Secondary
                }
            }
        }
    }
}
